module.exports = __webpack_public_path__ + "img/arrears_search.b3e805cd.png";